// Озвучка голосом системы (Web Speech API) — запасной вариант, когда у фразы или примера нет записи (audio.ts).
// Перед каждым запуском — cancel(), чтобы повторное нажатие не накладывало звук на звук.

const LANG = 'en-US';

function synth(): SpeechSynthesis | null {
  return typeof window !== 'undefined' && 'speechSynthesis' in window ? window.speechSynthesis : null;
}

function englishVoice(): SpeechSynthesisVoice | undefined {
  const voices = synth()?.getVoices() ?? [];
  const norm = (l: string) => l.replace('_', '-').toLowerCase();
  return voices.find((v) => norm(v.lang) === 'en-us') ?? voices.find((v) => norm(v.lang).startsWith('en'));
}

/** Есть ли API и английский голос. Список голосов может прийти позже — см. onVoicesChanged. */
export function canSpeak(): boolean {
  return !!synth() && !!englishVoice();
}

/** Голоса в части браузеров загружаются асинхронно: перерисовать кнопки, когда они появятся. */
export function onVoicesChanged(cb: () => void): void {
  const s = synth();
  if (s) s.addEventListener('voiceschanged', cb);
}

export function speak(text: string): void {
  const s = synth();
  const voice = englishVoice();
  if (!s || !voice || !text) return;
  s.cancel();
  const u = new SpeechSynthesisUtterance(text);
  u.lang = LANG;
  u.voice = voice;
  s.speak(u);
}

export function stopSpeech(): void {
  synth()?.cancel();
}
